<template>
  <v-container grid-list-sm fluid>
    <v-layout d-flex wrap v-bind="binding">
      <v-flex sm12 class="pa-2">
        <v-expansion-panels popout v-model="panelActivoPerfil" multiple>
          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Información de Contacto</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPanelInformacionContacto">
                <div
                  class="d-flex"
                  :class="{
                    'flex-column align-center': !isDesktop,
                    'justify-center': isDesktop
                  }"
                >
                  <div
                    class="d-flex flex-column justify-center mx-2"
                    style="width: 100%"
                  >
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-phone-in-talk"
                        v-model="infoContacto.telefonoFijo.valor"
                        label="Teléfono"
                        class="mx-2"
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        :disabled="!!!infoContacto.telefonoFijo.valor"
                        v-model="infoContacto.telefonoFijo.publico"
                        label="Público"
                        color="light-blue darken-2"
                      ></v-checkbox>
                    </div>
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-cellphone-sound"
                        v-model="infoContacto.celular.valor"
                        label="Número Celular"
                        class="mx-2"
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        :disabled="!!!infoContacto.celular.valor"
                        v-model="infoContacto.celular.publico"
                        label="Público"
                        color="light-blue darken-2"
                      ></v-checkbox>
                    </div>
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-email-search"
                        v-model="correoAlternativo"
                        label="Correo Electrónico"
                        class="mx-2"
                        hint="El correo electrónico siempre es público"
                        persistent-hint
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        disabled
                        v-model="correoPublico"
                        color="light-blue darken-2"
                        label="Público"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex"
                  :class="{
                    'flex-column align-center': !isDesktop,
                    'justify-center': isDesktop
                  }"
                >
                  <div
                    class="d-flex flex-column justify-center mx-2"
                    style="width: 100%"
                  >
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-linkedin"
                        v-model="infoContacto.linkedIn.valor"
                        label="Link a tu cuenta de LinkedIn"
                        class="mx-2"
                        hint="Ejemplo: https://www.linkedin.com/tu-nombre"
                        persistent-hint
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        :disabled="!!!infoContacto.linkedIn.valor"
                        v-model="infoContacto.linkedIn.publico"
                        label="Público"
                        color="light-blue darken-2"
                      ></v-checkbox>
                    </div>
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-facebook"
                        v-model="infoContacto.facebook.valor"
                        label="Link a tu perfil de Facebook"
                        class="mx-2"
                        hint="Ejemplo: https://www.facebook.com/tu-nombre"
                        persistent-hint
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        :disabled="!!!infoContacto.facebook.valor"
                        v-model="infoContacto.facebook.publico"
                        label="Público"
                        color="light-blue darken-2"
                      ></v-checkbox>
                    </div>
                    <div class="d-flex pb-2">
                      <v-text-field
                        prepend-inner-icon="mdi-twitter"
                        v-model="infoContacto.twitter.valor"
                        label="Link a tu perfil de Twitter"
                        class="mx-2"
                        hint="Ejemplo: https://www.twitter.com/tu-nombre"
                        persistent-hint
                      ></v-text-field>
                      <v-checkbox
                        class="d-flex flex-grow-0 flex-shrink-1"
                        :disabled="!!!infoContacto.twitter.valor"
                        v-model="infoContacto.twitter.publico"
                        label="Público"
                        color="light-blue darken-2"
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="userData.infoContacto">
                  <div
                    v-if="
                      Object.keys(userData.infoContacto).length ||
                      userData.correoAlternativo
                    "
                    class="d-flex justify-space-around"
                  >
                    <v-flex xs12>
                      <v-list-item-group>
                        <v-list-item
                          v-if="userData.infoContacto.telefonoFijo.valor"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Teléfono</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.infoContacto.telefonoFijo.valor"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2">
                              {{
                                userData.infoContacto.telefonoFijo.publico
                                  ? 'Público'
                                  : 'Privado'
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="light-blue darken-2"
                              target="_blank"
                              :href="`tel:${userData.infoContacto.telefonoFijo.valor}`"
                            >
                              <v-icon large>mdi-phone-in-talk</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="userData.infoContacto.celular.valor">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Celular</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.infoContacto.celular.valor"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2">
                              {{
                                userData.infoContacto.celular.publico
                                  ? 'Público'
                                  : 'Privado'
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="light-blue darken-2"
                              target="_blank"
                              :href="`tel:${userData.infoContacto.celular.valor}`"
                            >
                              <v-icon large>mdi-cellphone-sound</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="userData.correoAlternativo">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Correo</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.correoAlternativo"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2"
                              >Público</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="light-blue darken-2"
                              target="_blank"
                              :href="`mailto:${userData.correoAlternativo}`"
                            >
                              <v-icon large>mdi-email-search</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                          v-if="userData.infoContacto.linkedIn.valor"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Perfil de LinkedIn</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.infoContacto.linkedIn.valor"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2">
                              {{
                                userData.infoContacto.linkedIn.publico
                                  ? 'Público'
                                  : 'Privado'
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="blue darken-2"
                              target="_blank"
                              :href="`${userData.infoContacto.linkedIn.valor}`"
                            >
                              <v-icon large>mdi-linkedin</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                          v-if="userData.infoContacto.facebook.valor"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Perfil de Facebook</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.infoContacto.facebook.valor"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2">
                              {{
                                userData.infoContacto.facebook.publico
                                  ? 'Público'
                                  : 'Privado'
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="blue"
                              target="_blank"
                              :href="`${userData.infoContacto.facebook.valor}`"
                            >
                              <v-icon large>mdi-facebook</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="userData.infoContacto.twitter.valor">
                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold"
                              >Perfil de Twitter</v-list-item-title
                            >
                            <v-list-item-subtitle
                              class="text--primary mt-2"
                              v-text="userData.infoContacto.twitter.valor"
                            ></v-list-item-subtitle>
                            <v-list-item-subtitle class="text--secondary mt-2">
                              {{
                                userData.infoContacto.twitter.publico
                                  ? 'Público'
                                  : 'Privado'
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              color="#26c6da"
                              target="_blank"
                              :href="`${userData.infoContacto.twitter.valor}`"
                            >
                              <v-icon large>mdi-twitter</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-flex>
                  </div>
                </div>
                <div v-else class="d-flex justify-center mt-4 text--disabled">
                  Añade tu información para contacto como teléfonos o Redes
                  Sociales.
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn
                  v-if="editPanelInformacionContacto"
                  @click="editPanelInformacionContacto = false"
                  :disabled="fetching && editPanelInformacionContacto"
                  text
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="actionBtnInfoContacto"
                  :loading="fetching && editPanelInformacionContacto"
                >
                  <v-icon left color="light-blue darken-2">
                    mdi-{{
                      editPanelInformacionContacto
                        ? 'content-save-edit'
                        : 'plus-circle'
                    }}
                  </v-icon>
                  {{ editPanelInformacionContacto ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Sobre Mí</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPanelSobreMi">
                <v-textarea
                  name="sobreMi"
                  filled
                  label="Información sobre Mí"
                  auto-grow
                  counter="500"
                  v-model="sobreMi"
                ></v-textarea>
              </div>
              <div v-else>
                <div
                  v-if="userData.sobreMi != ''"
                  class="black--text font-weight-light title pt-5"
                >
                  {{ userData.sobreMi }}
                </div>
                <div v-else class="d-flex justify-center mt-2 text--disabled">
                  Añade una introducción sobre ti o una breve descripción tuya.
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn
                  text
                  v-if="editPanelSobreMi"
                  @click="editPanelSobreMi = false"
                  :disabled="fetching && editPanelSobreMi"
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="submitSobreMiInfo"
                  :loading="fetching && editPanelSobreMi"
                >
                  <v-icon left color="orange lighten-2">
                    mdi-{{
                      editPanelSobreMi ? 'content-save-edit' : 'plus-circle'
                    }}
                  </v-icon>
                  {{ editPanelSobreMi ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Habilidades</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPanelHabilidades">
                <div class="d-flex justify-center flex-column">
                  <v-text-field
                    label="Habilidades"
                    v-model="newHabilidad"
                    placeholder="Añade una nueva habilidad"
                    append-outer-icon="mdi-send"
                    filled
                    @click:append-outer="addNuevaHabilidad"
                  ></v-text-field>
                  <div class="d-flex flex-column">
                    <div
                      class="d-flex justify-center text--disabled"
                      v-if="!habilidades.length"
                    >
                      Aquí se agregarán las habilidades
                    </div>
                    <v-chip-group
                      class="black--text"
                      active-class
                      multiple
                      mandatory
                    >
                      <v-chip
                        v-for="(habilidades, index) in habilidades"
                        :key="index"
                        close
                        color="green accent-3"
                        active
                        @click:close="deleteHabilidad(index)"
                        >{{ habilidades }}</v-chip
                      >
                    </v-chip-group>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="!userData.habilidades.length"
                  class="d-flex justify-center mt-4 text--disabled"
                >
                  Añade las habilidades que tú consideres importantes.
                </div>
                <div v-else>
                  <v-chip-group active-class="black--text" mandatory>
                    <v-chip
                      v-for="(habilidades, index) in userData.habilidades"
                      :key="index"
                      color="green accent-3"
                      text-color="white"
                      >{{ habilidades }}</v-chip
                    >
                  </v-chip-group>
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn
                  v-if="editPanelHabilidades"
                  @click="editPanelHabilidades = false"
                  :disabled="fetching && editPanelHabilidades"
                  text
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="actionBtnPanelHabilidades"
                  :loading="fetching && editPanelHabilidades"
                >
                  <v-icon left color="green accent-3">
                    mdi-{{
                      editPanelHabilidades ? 'content-save-edit' : 'plus-circle'
                    }}
                  </v-icon>
                  {{ editPanelHabilidades ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Sitios Web</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPanelSitiosWeb">
                <div class="d-flex justify-start">
                  <v-btn
                    dark
                    small
                    color="light-green lighten-1"
                    @click="agregarOtrosWeb"
                  >
                    <v-icon left>mdi-plus-circle</v-icon>Agregar otra web
                  </v-btn>
                </div>
                <div class="d-flex justify-center flex-column align-start">
                  <div
                    class="d-flex flex-column justify-center mx-2 mt-6"
                    style="width: 100%"
                  >
                    <div v-if="sitiosWeb.otros.length">
                      <div
                        class="d-flex"
                        style="width: 100%"
                        v-for="(item, index) in sitiosWeb.otros"
                        :key="index"
                      >
                        <v-text-field
                          v-model="sitiosWeb.otros[index]"
                          label="Enlace a una Web externa"
                          prepend-icon="mdi-web-box"
                          append-outer-icon="mdi-close"
                          @click:append-outer="eliminarInfoSitiosWeb(index)"
                          class="mx-2 flex-shrink-1 flex-grow-1"
                        ></v-text-field>
                      </div>
                    </div>
                    <div
                      v-else
                      class="subtitle justify-center d-flex text--disabled mb-6"
                    >
                      Aquí se mostrarán los diferentes sitios web que irás
                      agregando.
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    <v-text-field
                      v-model="sitiosWeb.github"
                      label="Enlace a Github"
                      prepend-icon="mdi-github"
                      class="mx-2 flex-shrink-1 flex-grow-0"
                    ></v-text-field>
                    <v-text-field
                      v-model="sitiosWeb.gitlab"
                      label="Enlace a Gitlab"
                      prepend-icon="mdi-gitlab"
                      class="mx-2 flex-shrink-1 flex-grow-0"
                    ></v-text-field>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="userData.sitiosWeb">
                  <div
                    class="d-flex flex-column justify-center"
                    v-if="userData.sitiosWeb.otros"
                  >
                    <div v-if="userData.sitiosWeb.otros.length">
                      <v-list two-line style="width: 100%">
                        <v-list-item-group
                          v-model="selected"
                          active-class="blue--text"
                        >
                          <template
                            v-for="(item, index) in userData.sitiosWeb.otros"
                          >
                            <v-list-item
                              :key="`sitio:${index}`"
                              :style="{
                                width: isDesktop ? '100%' : '90vw'
                              }"
                              :href="item"
                              target="_blank"
                            >
                              <template>
                                <v-list-item-icon class="my-auto">
                                  <v-icon color="blue">mdi-web</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title
                                    style="white-space: initial"
                                    >{{ item }}</v-list-item-title
                                  >
                                </v-list-item-content>
                                <v-list-item-icon class="my-auto">
                                  <v-icon
                                    :color="
                                      index == selected
                                        ? 'blue'
                                        : 'grey lighten-1'
                                    "
                                    >mdi-open-in-new</v-icon
                                  >
                                </v-list-item-icon>
                              </template>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </div>
                    <div
                      v-else-if="
                        !userData.sitiosWeb.github && !userData.sitiosWeb.gitlab
                      "
                      class="d-flex justify-center mt-4 text--disabled"
                    >
                      Añade links de páginas web que demuestren tu experiencia o
                      conocimiento.
                    </div>
                  </div>
                  <v-divider
                    v-if="
                      userData.sitiosWeb.otros &&
                      userData.sitiosWeb.otros.length
                    "
                  ></v-divider>
                  <div
                    v-if="
                      userData.sitiosWeb.github || userData.sitiosWeb.gitlab
                    "
                  >
                    <v-list two-line style="width: 100%">
                      <v-list-item-group
                        v-model="selectedAdicional"
                        active-class="blue--text"
                      >
                        <v-list-item
                          :style="{
                            width: isDesktop ? '100%' : '90vw'
                          }"
                          :href="userData.sitiosWeb.github"
                          target="_blank"
                          v-if="userData.sitiosWeb.github"
                        >
                          <template>
                            <v-list-item-icon class="my-auto">
                              <v-icon color="black">mdi-github</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title style="white-space: initial">
                                {{ userData.sitiosWeb.github }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-auto">
                              <v-icon
                                :color="
                                  selectedAdicional === 0
                                    ? 'blue'
                                    : 'grey lighten-1'
                                "
                                >mdi-open-in-new</v-icon
                              >
                            </v-list-item-icon>
                          </template>
                        </v-list-item>

                        <v-list-item
                          :style="{
                            width: isDesktop ? '100%' : '90vw'
                          }"
                          :href="userData.sitiosWeb.gitlab"
                          target="_blank"
                          v-if="userData.sitiosWeb.gitlab"
                        >
                          <template>
                            <v-list-item-icon class="my-auto">
                              <v-icon color="orange">mdi-gitlab</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title style="white-space: initial">
                                {{ userData.sitiosWeb.gitlab }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon class="my-auto">
                              <v-icon
                                :color="
                                  selectedAdicional === 1
                                    ? 'blue'
                                    : 'grey lighten-1'
                                "
                                >mdi-open-in-new</v-icon
                              >
                            </v-list-item-icon>
                          </template>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </div>
                </div>

                <div v-else class="d-flex justify-center mt-4 text--disabled">
                  Añade links de páginas web que demuestren tu experiencia o
                  conocimiento.
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn
                  v-if="editPanelSitiosWeb"
                  @click="editPanelSitiosWeb = false"
                  :disabled="fetching && editPanelSitiosWeb"
                  text
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="actionBtnSitiosWeb"
                  :loading="fetching && editPanelSitiosWeb"
                >
                  <v-icon left color="light-green lighten-1">
                    mdi-{{
                      editPanelSitiosWeb ? 'content-save-edit' : 'plus-circle'
                    }}
                  </v-icon>
                  {{ editPanelSitiosWeb ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['userData'],
  data: function () {
    return {
      panelActivoPerfil: [0, 1, 2, 3],
      editPanelSobreMi: false,
      sobreMi: '',
      editPanelHabilidades: false,
      newHabilidad: '',
      habilidades: [],
      editPanelInformacionContacto: false,
      infoContacto: {},
      correoAlternativo: '',
      correoPublico: true,
      editPanelSitiosWeb: false,
      sitiosWeb: {},
      selected: null,
      selectedAdicional: null
    }
  },

  methods: {
    async submitSobreMiInfo() {
      if (this.editPanelSobreMi) {
        let body = {
          sobreMi: this.sobreMi
        }
        let response = await this.updateProfileInfo(body)
        if (response.success) {
          this.editPanelSobreMi = false
          this.userData.sobreMi = this.cleanSource(this.sobreMi)
        }
      } else {
        this.editPanelSobreMi = true
        this.sobreMi = this.cleanSource(this.userData.sobreMi)
      }
    },

    async actionBtnPanelHabilidades() {
      this.snackbar = false
      if (this.editPanelHabilidades) {
        let response = await this.updateProfileInfo({
          habilidades: this.habilidades
        })
        if (response.success) {
          this.editPanelHabilidades = false
          this.userData.habilidades = this.cleanSource(this.habilidades)
        }
      } else {
        this.habilidades = this.cleanSource(this.userData.habilidades)
        this.editPanelHabilidades = true
      }
    },

    addNuevaHabilidad() {
      if (this.newHabilidad != '') {
        this.habilidades.push(this.newHabilidad)
        this.newHabilidad = ''
      }
    },

    deleteHabilidad(index) {
      this.habilidades.splice(index, 1)
    },

    async actionBtnInfoContacto() {
      if (this.editPanelInformacionContacto) {
        let body = {
          infoContacto: this.infoContacto
        }
        if (this.correoAlternativo != this.userData.correoAlternativo)
          body.correoAlternativo = this.correoAlternativo
        let response = await this.updateProfileInfo(body)
        if (response.success) {
          this.editPanelInformacionContacto = false
          this.userData.infoContacto = this.cleanSource(this.infoContacto)
          if (this.correoAlternativo != this.userData.correoAlternativo)
            this.userData.correoAlternativo = body.correoAlternativo
        }
      } else {
        this.infoContacto = this.userData.infoContacto
          ? this.cleanSource(this.userData.infoContacto)
          : {
              telefonoFijo: {
                valor: '',
                publico: false
              },
              celular: {
                valor: '',
                publico: false
              },
              facebook: {
                valor: '',
                publico: false
              },
              twitter: {
                valor: '',
                publico: false
              },
              linkedIn: {
                valor: '',
                publico: false
              }
            }
        this.correoAlternativo = this.cleanSource(
          this.userData.correoAlternativo
        )
        this.editPanelInformacionContacto = true
      }
    },

    async actionBtnSitiosWeb() {
      if (this.editPanelSitiosWeb) {
        let body = {
          sitiosWeb: this.sitiosWeb
        }

        let response = await this.updateProfileInfo(body)

        if (response.success) {
          this.editPanelSitiosWeb = false
          this.userData.sitiosWeb = this.cleanSource(this.sitiosWeb)
        }
      } else {
        this.sitiosWeb = this.userData.sitiosWeb
          ? this.cleanSource(this.userData.sitiosWeb)
          : {
              github: '',
              gitlab: '',
              otros: []
            }
        this.editPanelSitiosWeb = true
      }
    },

    agregarOtrosWeb() {
      if (!this.sitiosWeb.otros) this.sitiosWeb.otros = []
      this.sitiosWeb.otros.push('')
    },

    eliminarInfoSitiosWeb(index) {
      this.sitiosWeb.otros.splice(index, 1)
    },

    cleanSource(source) {
      // using native JSON functions removes reactivity
      // so we can clone an object without mutating the original source
      return JSON.parse(JSON.stringify(source))
    },

    ...mapActions('user', ['updateProfileInfo', 'getProfileInfo'])
  },

  computed: {
    binding() {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },

    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp
    },

    ...mapGetters('user', ['getError', 'fetching'])
  }
}
</script>

<style>
</style>